var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99967 3.33325C10.4599 3.33325 10.833 3.70635 10.833 4.16659V9.16658H15.833C16.2932 9.16658 16.6663 9.53968 16.6663 9.99992C16.6663 10.4602 16.2932 10.8333 15.833 10.8333H10.833V15.8333C10.833 16.2935 10.4599 16.6666 9.99967 16.6666C9.53944 16.6666 9.16634 16.2935 9.16634 15.8333V10.8333H4.16634C3.7061 10.8333 3.33301 10.4602 3.33301 9.99992C3.33301 9.53968 3.7061 9.16658 4.16634 9.16658H9.16634V4.16659C9.16634 3.70635 9.53944 3.33325 9.99967 3.33325Z",
    fill: "#12A232"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenPlus);
export default __webpack_public_path__ + "static/media/green-plus.c02b7b3756db9583633733a06342f367.svg";
export { ForwardRef as ReactComponent };